import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPlay,
  faCopy,
  faRefresh,
  faDownload,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import { postRequest, getRequest } from "../../utils/axios";
import { NotificationManager } from "react-notifications";
import axios from "axios";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { RequestStatus } from "../../utils/RequestStatus";

import MainA from "../../layout/Main Admin";
import Input from "../../components/atoms/Input";
import Upload from "../../components/atoms/Upload";
import Button from "../../components/atoms/Button";
import Loader from "../../components/atoms/Loader";
import Modal from "../../components/atoms/Modal";
import Table from "../../components/atoms/Table";
import CertificateViewer from "../../components/molecules/CertificateViewer";

import moment from "moment";

import uploadImage from "../../assets/icons/upload_image.svg";
import plus from "../../assets/icons/plus.svg";

import "./styles.scss";

const EventClip = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const playVideoRef = useRef(null);
  const reelVideoRefs = useRef({});
  const { pageId } = useParams();
  const [clipData, setClipData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const imageUrl = "https://dynamicproductstorage.blob.core.windows.net/reels";
  const [isAddImageModalOpen, setIsAddImageModalOpen] = useState(false);
  const [eventData, setEventData] = useState([]);
  const [playUrl, setPlayUrl] = useState("");
  const [isPlayModalOpen, setIsPlayModalOpen] = useState(false);
  const [driveUrl, setDriveUrl] = useState("");
  const [participantData, setParticipantData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [processedFaces, setProcessedFaces] = useState([]);
  const [sortColumn, setSortColumn] = useState("bibNo");
  const [sortOrder, setSortOrder] = useState("asc");
  const [segregationStatus, setSegregationStatus] = useState("");
  const [generateReelStatus, setGenerateReelStatus] = useState("");
  const [processByFaceStatus, setProcessByFaceStatus] = useState("");
  const queryParams = new URLSearchParams(location.search);
  const categoryIdFromQuery = queryParams.get("categoryId");
  const [galleryFileTitle, setGalleryFileTitle] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [resetFile, setResetFile] = useState(0);
  const [processedCount, setProcessedCount] = useState(0);
  const [isReelModalOpen, setIsReelModalOpen] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState([]);
  const [signedReels, setSignedReels] = useState({});
  const [expandedReelKey, setExpandedReelKey] = useState(null);
  const [demoReelImages, setDemoReelImages] = useState([]);
  const [selectedDemoImages, setSelectedDemoImages] = useState([]);
  const [activePill, setActivePill] = useState("ALL");
  const [searchTerm, setSearchTerm] = useState("");
  const [imageCount, setImageCount] = useState([]);
  const [isCleanModalOpen, setIsCleanModalOpen] = useState(false);
  const [folderSize, setFolderSize] = useState([]);
  const [cleanLoading, setCleanLoading] = useState({
    processedReels: false,
    processedImages: false,
    unprocessedImages: false,
  });
  const [faceSegConfirmOpen, setFaceSegConfirmOpen] = useState(false);
  const [faceSegLoading, setFaceSegLoading] = useState(false);
  const [faceSegTotal, setFaceSegTotal] = useState(0);
  const [faceSegProcessed, setFaceSegProcessed] = useState(0);
  const [unprocessedFaceParticipants, setUnprocessedFaceParticipants] = useState([]);
  const [showCertificateViewer, setShowCertificateViewer] = useState(false);
  const [certificateRunType, setCertificateRunType] = useState(null);
  const [autoReelRequest, setAutoReelRequest] = useState([]);

  useEffect(() => {
    getClipByPageId(pageId);
    getEvent();
    fetchParticipants(pageId);
    getImageCount();
    getSegregationStatus();
    getGenerateReelStatus();
    getDemoReelImages();
    getCleanDataStatus();
    getUnprocessedFaceParticipants();
    getProcessedFaces();
  }, []);

  useEffect(() => {
    if (isReelModalOpen && selectedParticipant?.reels?.length > 0) {
      generateSignedUrls();
    }
  }, [isReelModalOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("file", imageFile);
    formData.append("EventClipTitle", galleryFileTitle);
    formData.append("PageId", eventData?.pageId);

    try {
      setActionLoading(true);

      const resp = await postRequest(`EventClip/PostEventClip`, formData);

      if (resp.status === 200) {
        NotificationManager.success("Clip uploaded successfully");
        setGalleryFileTitle("");
        setImageFile("");
        setResetFile(resetFile + 1);
        setIsAddImageModalOpen(false);
        getClipByPageId(pageId);
      } else {
        NotificationManager.error("Upload failed");
      }
    } catch (error) {
      NotificationManager.error("Network error occurred");
    } finally {
      setActionLoading(false);
    }
  };

  const handleUpload = (file) => {
    setImageFile(file);
    const fileName = file.name;
    if (galleryFileTitle === "") {
      setGalleryFileTitle(fileName);
    }
  };

  const handleGalleryFileTitleChange = (e) => {
    setGalleryFileTitle(e.target.value);
  };
  const handleDriveUrlChange = (e) => {
    setDriveUrl(e.target.value);
  };

  const handleAddImage = () => {
    setIsAddImageModalOpen(true);
  };

  const getEvent = async () => {
    try {
      const resp = await getRequest(`Page/GetPageById/${pageId}`);
      setEventData(resp.data);
      setDriveUrl(resp.data?.driveUrl);
    } catch (error) {
      console.error("Error fetching event:", error);
    }
  };
  const getImageCount = async () => {
    try {
      const resp = await getRequest(`EventImages/GetImageCounts/${pageId}`);
      setImageCount(resp.data);
    } catch (error) {
      console.error("Error fetching count:", error);
    }
  };

  const getDemoReelImages = async () => {
    try {
      const resp = await getRequest(`S3/GetDemoReelImages`);
      setDemoReelImages(resp.data);
    } catch (error) {
      console.error("Error fetching demo images:", error);
    }
  };
  const getProcessedFaces = async () => {
    try {
      const resp = await getRequest(`EventUserFaceProcessed/GetEventUserFaceByPageId/${pageId}`);
      const uniqueProcessedEmails = [...new Set(resp.data.map((item) => item.email))];
      setProcessedFaces(uniqueProcessedEmails);
    } catch (error) {
      console.error("Error fetching processed faces:", error);
    }
  };
  const getClipByPageId = async (pageId) => {
    try {
      const resp = await getRequest(`EventClip/GetEventClipByPageId/${pageId}`);
      setClipData(resp.data[0]);
    } catch (error) {
      console.error("Error fetching clip:", error);
    }
  };
  const getSegregationStatus = async () => {
    try {
      const resp = await getRequest(
        `EventRequest/GetEventRequestByEventIdAndRequestType/${pageId}/PROCESS_EVENT_IMAGES`,
      );

      const bibRecords = (resp?.data || []).filter((r) => r.processingMode === "bib");
      const faceRecords = (resp?.data || []).filter((r) => r.processingMode === "face");

      const bibSortedRequests = (bibRecords || []).sort(
        (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );
      const faceSortedRequests = (faceRecords || []).sort(
        (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );

      setSegregationStatus(bibSortedRequests[0]?.status);
      setProcessByFaceStatus(faceSortedRequests[0]?.status);
    } catch (error) {
      console.error("Error fetching segregation data:", error);
    }
  };
  const getGenerateReelStatus = async () => {
    try {
      const resp = await getRequest(
        `EventRequest/GetEventRequestByEventIdAndRequestType/${pageId}/GENERATE_EVENT_REELS`,
      );
      const noBibRecords = (resp?.data || []).filter((r) => r.bibId == null);
      setAutoReelRequest(noBibRecords);
      const sortedRequests = noBibRecords.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
      setGenerateReelStatus(sortedRequests[0]?.status ?? null);
    } catch (error) {
      console.error("Error fetching reel data:", error);
    }
  };

  const handleDriveUrlSubmit = async (e) => {
    e.preventDefault();

    try {
      setActionLoading(true);

      const resp = await getRequest(
        `Page/UpdateDriveUrl/${eventData?.pageId}?driveUrl=${driveUrl}`,
      );

      if (resp.status === 200) {
        NotificationManager.success("Url uploaded successfully");
        getEvent();
      } else {
        NotificationManager.error("Upload failed");
      }
    } catch (error) {
      NotificationManager.error("Network error occurred");
    } finally {
      setActionLoading(false);
    }
  };

  const handleSort = (column) => {
    const order = sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
    setSortColumn(column);
    setSortOrder(order);

    const sortedData = [...filteredData].sort((a, b) => {
      const aValue = a[column] || "";
      const bValue = b[column] || "";

      if (aValue < bValue) return order === "asc" ? -1 : 1;
      if (aValue > bValue) return order === "asc" ? 1 : -1;
      return 0;
    });

    setFilteredData(sortedData);
  };

  const fetchParticipants = async (pageId) => {
    try {
      const [participantsRes, reelsRes] = await Promise.all([
        getRequest(`EventParticipant/GetEventParticipants/${pageId}`),
        getRequest(`EventReel/GetEventReelByEventId/${pageId}`),
      ]);

      const participants = participantsRes.data || [];
      const reels = reelsRes.data || [];
      const reelCountWithPath = reels.filter(
        (reel) => reel.reelPath && reel.reelPath.trim() !== "",
      ).length;
      setProcessedCount(reelCountWithPath);

      const mergedData = mergeByBibId(participants, reels);

      setParticipantData(mergedData);
      setFilteredData(mergedData);
    } catch (error) {
      NotificationManager.error("Failed to fetch participants.");
      console.error(error);
    }
  };

  const mergeByBibId = (participants, reels) => {
    const reelMap = new Map();

    reels.forEach((reel) => {
      if (!reel.bibId) return;

      if (!reelMap.has(reel.bibId)) {
        reelMap.set(reel.bibId, []);
      }

      if (reel.reelPath && reel.reelPath.trim() !== "") {
        reelMap.get(reel.bibId).push({
          reelPath: reel.reelPath,
          requestId: reel.requestId,
          createdAt: reel.createdAt,
        });
      }
    });

    return participants.map((participant) => ({
      ...participant,
      reels: reelMap.get(participant.bibNo) || [], // always an array
    }));
  };

  const handleMail = async () => {
    try {
      if (participantData.length === 0) {
        NotificationManager.error("No participants found.");
        return;
      }
      const mailData = participantData
        .filter((participant) => participant.reels.length > 0)
        .map((participant) => ({
          bibNo: participant.bibNo,
          completionTime: participant.completionTime,
          email: participant.email,
          participantName: participant.participantName,
          ticketName: participant.ticketName,
          reels: participant.reels,
          eventName: eventData?.pageTitle,
        }));
      const response = await axios.post(
        `https://01fa4a69f901eb878abce8a5deff7e.dd.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/90f8817003af48fca44e75993c4b4132/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=u9JQVVIdQAUuaUOqV42D6tPOGn_5vrf0Jd_V_nY2xo4`,
        mailData,
      );
      NotificationManager.success("Mail sent successfully");
    } catch (error) {
      NotificationManager.error("Failed to send mail.");
      console.error(error);
    }
  };

  const handleParticipantMail = async () => {
    try {
      const mailData = [
        {
          bibNo: selectedParticipant.bibNo,
          completionTime: selectedParticipant.completionTime,
          email: selectedParticipant.email,
          participantName: selectedParticipant.participantName,
          ticketName: selectedParticipant.ticketName,
          reels: selectedParticipant.reels,
          eventName: eventData?.pageTitle,
        },
      ];
      const response = await axios.post(
        `https://01fa4a69f901eb878abce8a5deff7e.dd.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/90f8817003af48fca44e75993c4b4132/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=u9JQVVIdQAUuaUOqV42D6tPOGn_5vrf0Jd_V_nY2xo4`,
        mailData,
      );
      NotificationManager.success("Mail sent successfully");
    } catch (error) {
      NotificationManager.error("Failed to send mail.");
      console.error(error);
    }
  };

  // const handleGenerateReel = async() => {
  //   try{
  //     if (!eventData?.driveUrl) {
  //       NotificationManager.error("Add drive url to generate a reel");
  //       return;
  //     } else if (!clipData) {
  //       NotificationManager.error("Add clip to generate a reel");
  //       return;
  //     } else if (participantData.length <= 0) {
  //       NotificationManager.error(
  //         "Add atleast one participant to generate a reel"
  //       );
  //       return;
  //     }
  //     const payload = {
  //       eventId: eventData?.pageId,
  //       reelS3Key: `${eventData?.pageId}/BackgroundReel/${clipData.eventClipFileName}`,
  //       reelConfiguration: "{\"overlays\":[{\"type\":\"text\",\"text\":\"Bib No: ${bibId}\\nRunner: ${runner}\\nCompletion Time: ${completionTime}\\nCategory: ${category}\",\"start_time\":5,\"duration\":3,\"position\":\"center\",\"text_style\":{\"font_size\":60,\"color\":\"#FFFFFF\",\"stroke_color\":\"#000000\",\"stroke_width\":3,\"padding\":100,\"align\":\"top-center\",\"char_animation\":false,\"char_fade_duration\":0.01,\"char_delay\":0.03,\"bg_gradient\":{\"start\":\"#000000FF\",\"end\":\"#000000FF\"}}},{\"type\":\"image_stack\",\"start_time\":7,\"duration\":6,\"position\":\"center\",\"bg_color\":\"#FFFFFF\",\"width\":0.7,\"height\":0.7,\"fit_mode\":\"cover\",\"rotation_range\":15,\"opacity\":1}]}"
  //     };

  //     const resp = await postRequest(`EventRequest/GenerateEventReels`, payload);
  //     setGenerateReelStatus("IN_PROGRESS");
  //     if (resp.status === 200) {
  //       NotificationManager.success("Request submitted successfully");
  //     }

  //   } catch (error) {
  //     NotificationManager.error("Failed to segregate images.");
  //     console.error(error);
  //   }
  // };

  const handleGenerateReel = async () => {
    try {
      if (!eventData?.driveUrl) {
        NotificationManager.error("Add drive url to generate a reel");
        return;
      } else if (!clipData) {
        NotificationManager.error("Add clip to generate a reel");
        return;
      } else if (participantData.length <= 0) {
        NotificationManager.error(
          "Add atleast one participant to generate a reel",
        );
        return;
      }
      const payload = {
        requestId: crypto.randomUUID(),
        eventId: eventData?.pageId,
        reelS3Key: `${eventData?.pageId}/BackgroundReel/${clipData.eventClipFileName}`,
        reelConfiguration:
          '{"overlays":[{"type":"text","text":"Bib No: ${bibId}\\n ${runner}\\nCompletion Time: ${completionTime}\\nCategory: ${category}","start_time":5,"duration":2,"position":"center","text_style":{"font_size":100,"font":"Caveat Brush","color":"#FFFFFF","stroke_color":"#000000","stroke_width":3,"padding":100,"align":"top-center","char_animation":false,"char_fade_duration":0.01,"char_delay":0.03,"bg_gradient":{"start":"#000000FF","end":"#000000FF"}}},{"type":"image_stack","start_time":7,"duration":6,"position":"center","bg_color":"#FFFFFF","width":0.7,"height":0.7,"fit_mode":"contain","rotation_range":0,"opacity":1}]}',
      };

      const resp = await fetch(
        "https://rtz96eyzva.execute-api.ap-south-1.amazonaws.com/prod/generate-event-reels",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_AWS_API_KEY,
          },
          body: JSON.stringify(payload),
        },
      );
      setGenerateReelStatus("IN_PROGRESS");
      if (resp.status === 200) {
        NotificationManager.success("Request submitted successfully");
      }
    } catch (error) {
      NotificationManager.error("Failed to generate reel.");
      console.error(error);
    }
  };

  // const handleSegregateImages = async() => {
  //   try{
  //     if (!eventData?.driveUrl) {
  //       NotificationManager.error("Add drive url to start segregating images");
  //       return;
  //     }else if (participantData.length <= 0) {
  //       NotificationManager.error(
  //         "Add atleast one participant to generate a reel"
  //       );
  //       return;
  //     }

  //     const payload = {
  //       eventId: eventData?.pageId,
  //       driveUrl: eventData?.driveUrl,
  //       csvKey: `${eventData?.pageId}/participants.csv`
  //     };

  //     const resp = await postRequest(`EventRequest/ProcessEventImages`, payload);
  //     setSegregationStatus("IN_PROGRESS");
  //     if (resp.status === 200) {
  //       NotificationManager.success("Request submitted successfully");
  //     }

  //   } catch (error) {
  //     NotificationManager.error("Failed to segregate images.");
  //     console.error(error);
  //   }
  // };

  const handleSegregateImagesByBib = async () => {
    try {
      if (!eventData?.driveUrl) {
        NotificationManager.error("Add drive url to start segregating images");
        return;
      } else if (participantData.length <= 0) {
        NotificationManager.error(
          "Add atleast one participant to start segregating images",
        );
        return;
      }
      // if (!clipData) {
      //   NotificationManager.error("Add clip to generate demo reel");
      //   return;
      // }

      const payload = {
        requestId: crypto.randomUUID(),
        eventId: eventData.pageId,
        gdriveFolderUrl: eventData.driveUrl,
        csvKey: `${eventData.pageId}/participants.csv`,
        processingMode: "bib"
      };

      const resp = await fetch(
        "https://rtz96eyzva.execute-api.ap-south-1.amazonaws.com/prod/process-event-images",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_AWS_API_KEY,
          },
          body: JSON.stringify(payload),
        },
      );
      setSegregationStatus("IN_PROGRESS");
      if (resp.status === 200) {
        NotificationManager.success("Request submitted successfully");
      }
    } catch (error) {
      NotificationManager.error("Failed to segregate images.");
      console.error(error);
    }
  };

  const handleProcessFace = async () => {
    try {
      if (!eventData?.driveUrl) {
        NotificationManager.error("Add drive url to start processing face detection");
        return;
      } else if (participantData.length <= 0) {
        NotificationManager.error(
          "Add atleast one participant to start processing face detection",
        );
        return;
      }
      // if (!clipData) {
      //   NotificationManager.error("Add clip to generate demo reel");
      //   return;
      // }

      const payload = {
        requestId: crypto.randomUUID(),
        eventId: eventData.pageId,
        gdriveFolderUrl: eventData.driveUrl,
        csvKey: `${eventData.pageId}/participants.csv`,
        processingMode: "face"
      };

      const resp = await fetch(
        "https://rtz96eyzva.execute-api.ap-south-1.amazonaws.com/prod/process-event-images",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_AWS_API_KEY,
          },
          body: JSON.stringify(payload),
        },
      );
      setProcessByFaceStatus("IN_PROGRESS");
      if (resp.status === 200) {
        NotificationManager.success("Request submitted successfully");
      }
    } catch (error) {
      NotificationManager.error("Failed to process face detection.");
      console.error(error);
    }
  };

  const getUnprocessedFaceParticipants = async () => {
    try {
      const resp = await getRequest(
        `EventParticipant/GetUnprocessedFaceParticipant/${pageId}`
      );
      setUnprocessedFaceParticipants(resp.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSegregateImagesByFace = async () => {
    try {
      if (faceSegLoading) return;

      if (!eventData?.driveUrl) {
        NotificationManager.error("Add drive url to start segregating images by face");
        return;
      }

      // if (!clipData) {
      //   NotificationManager.error("Add clip to generate demo reel");
      //   return;
      // }

      if (unprocessedFaceParticipants.length === 0) {
        NotificationManager.info("All participants already processed");
        return;
      }

      setFaceSegTotal(unprocessedFaceParticipants.length);
      setFaceSegProcessed(0);
      setFaceSegLoading(true);

      let processed = 0;
      let error = "";

      const requestPayload = {
        eventId: eventData.pageId,
        requestType: "PROCESS_UNPROCESSED_IMAGES_BY_FACE",
        status: "IN_PROGRESS"
      };

      const reqResp = await postRequest(`EventRequest/Add`, requestPayload);
      const reqData = reqResp.data;

      for (const p of unprocessedFaceParticipants) {

        try {

          const postPayload = {
            bibNumber: p.bibNo,
            eventId: p.eventId,
            phone: p.phoneNo,
            profilePhoto: `profile/${p.profileImage}`,
            email: p.email
          };

          const resp = await fetch(
            "https://rtz96eyzva.execute-api.ap-south-1.amazonaws.com/prod/register-user-face",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "x-api-key": process.env.REACT_APP_AWS_API_KEY,
              },
              body: JSON.stringify(postPayload),
            }
          );

          if (resp.ok) {

            await postRequest(`EventUserFaceProcessed/Add`, {
              pageId: p.eventId,
              userId: p.userId,
              email: p.email,
            });

          } else {

            const errText = await resp.text();
            error += `${p.email}: ${errText}\n`;

          }

        } catch (err) {
          error += `${p.email}: ${err.message}\n`;
        }

        processed++;
        setFaceSegProcessed(processed);
      }

      const updateReqPayload = {
        requestId: reqData.requestId,
        eventId: eventData.pageId,
        requestType: "PROCESS_UNPROCESSED_IMAGES_BY_FACE",
        status: error === ""
          ? "SUCCESS"
          : "PARTIAL_SUCCESS",
        error: error
      };

      await postRequest(`EventRequest/Update`, updateReqPayload);

    } catch (err) {

      console.error(err);
      NotificationManager.error("Failed to segregate images");

    } finally {

      setFaceSegLoading(false);

    }
  };

  const handleGenerateDemoReel = async () => {
    try {
      if (!clipData) {
        NotificationManager.error("Add clip to generate demo reel");
        return;
      }

      const payload = {
        requestId: String(eventData?.pageId),
        eventId: eventData?.pageId,
        reelS3Key: `${eventData?.pageId}/BackgroundReel/${clipData.eventClipFileName}`,
        reelConfiguration:
          '{"overlays":[{"type":"text","text":"Bib No: ${bibId}\\n ${runner}\\nCompletion Time: ${completionTime}\\nCategory: ${category}","start_time":5,"duration":2,"position":"center","text_style":{"font_size":100,"font":"Caveat Brush","color":"#FFFFFF","stroke_color":"#000000","stroke_width":3,"padding":100,"align":"top-center","char_animation":false,"char_fade_duration":0.01,"char_delay":0.03,"bg_gradient":{"start":"#000000FF","end":"#000000FF"}}},{"type":"image_stack","start_time":7,"duration":6,"position":"center","bg_color":"#FFFFFF","width":0.7,"height":0.7,"fit_mode":"contain","rotation_range":0,"opacity":1}]}',
        bibId: "-1",
        imageS3Keys: selectedDemoImages,
      };

      const resp = await fetch(
        "https://rtz96eyzva.execute-api.ap-south-1.amazonaws.com/prod/generate-event-reels",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_AWS_API_KEY,
          },
          body: JSON.stringify(payload),
        },
      );
      if (resp.status === 200) {
        NotificationManager.success("Request submitted successfully");
        setSelectedDemoImages([]);
      }
    } catch (error) {
      NotificationManager.error("Failed to generate reel.");
      console.error(error);
    }
  };

  const RequestStatusLabel = {
    [RequestStatus.Requested]: "Requested",
    [RequestStatus.InProgress]: "In Progress",
    [RequestStatus.Completed]: "Completed",
    [RequestStatus.Error]: "Error",
    [RequestStatus.Cancelled]: "Cancelled",
  };

  const handleOpenReelModal = (item) => {
    if (!item.reels || item?.reels?.length === 0) {
      NotificationManager.info("No reels available");
      return;
    }
    setSelectedParticipant(item);
    setIsReelModalOpen(true);
  };

  const isMailDisabled =
    participantData.length === 0 ||
    !participantData.some(
      (participant) => participant.reels && participant.reels.length > 0,
    );

  const generateSignedUrls = async () => {
    try {
      const urls = {};

      await Promise.all(
        selectedParticipant.reels.map(async (reel) => {
          const resp = await getRequest(
            `S3/GetPreSignedUrl?key=${encodeURIComponent(reel.reelPath)}`,
          );

          urls[reel.reelPath] = resp.data.url;
        }),
      );

      setSignedReels(urls);
    } catch (error) {
      console.error("Failed to generate signed URLs", error);
    }
  };

  const handlePlayClick = (reelPath) => {
    Object.entries(reelVideoRefs.current).forEach(([key, video]) => {
      if (key !== reelPath && video) {
        video.pause();
        video.currentTime = 0;
      }
    });

    setExpandedReelKey((prev) => (prev === reelPath ? null : reelPath));
  };

  const handleSelectDemoImages = (imageKey) => {
    setSelectedDemoImages((prev) =>
      prev.includes(imageKey)
        ? prev.filter((k) => k !== imageKey)
        : [...prev, imageKey],
    );
  };

  const handlePillClick = (type) => {
    setActivePill(type);
    applyFilters(type, searchTerm);
  };

  const applyFilters = (pillType, searchValue) => {
    let data = [...participantData];

    if (pillType === "PROCESSED") {
      data = data.filter((p) => p.reels && p.reels.length > 0);
    }

    if (searchValue) {
      const q = searchValue.toLowerCase();

      data = data.filter(
        (p) =>
          String(p.bibNo).toLowerCase().includes(q) ||
          p.participantName?.toLowerCase().includes(q) ||
          p.email?.toLowerCase().includes(q) ||
          p.phoneNo?.toLowerCase().includes(q),
      );
    }

    setFilteredData(data);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    applyFilters(activePill, value);
  };

  const handleClosePlayModal = () => {
    if (playVideoRef.current) {
      playVideoRef.current.pause();
      playVideoRef.current.currentTime = 0;
    }
    setIsPlayModalOpen(false);
  };

  const handleCloseReelModal = () => {
    Object.values(reelVideoRefs.current).forEach((video) => {
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });

    setExpandedReelKey(null);
    setIsReelModalOpen(false);
  };

  const getCleanDataStatus = async () => {
    try {
      const resp = await getRequest(`CleanDataRequest/GetByPage/${pageId}`);

      if (resp.status === 200 && resp.data) {

        const loadingState = {
          processedReels: false,
          processedImages: false,
          unprocessedImages: false,
        };

        resp.data.forEach((req) => {
          const isInProgress = req.status?.toLowerCase() === "inprogress";

          switch (req.requestType) {
            case "ProcessedReels":
              loadingState.processedReels = isInProgress;
              break;

            case "ProcessedImages":
              loadingState.processedImages = isInProgress;
              break;

            case "UnprocessedImages":
              loadingState.unprocessedImages = isInProgress;
              break;

            default:
              break;
          }
        });

        setCleanLoading(loadingState);
      }
    } catch (error) {
      console.error("Error fetching clean data status:", error);
    }
  };

  const handleCloseCleanModal = () => {
    setIsCleanModalOpen(false);
  };

  const handleCleanProcessedReels = async () => {
    setCleanLoading((prev) => ({ ...prev, processedReels: true }));

    try {
      const resp = await getRequest(
        `EventReel/DeleteReelsForEventRequests/${pageId}`,
      );

      if (resp.status === 200) {
        NotificationManager.success("Reels cleaned successfully");
        fetchParticipants(pageId);
        getFolderSize();
      }
    } catch (error) {
      console.error("Error deleting reels:", error);
    } finally {
      setCleanLoading((prev) => ({ ...prev, processedReels: false }));
    }
  };

  const handleCleanProcessedImages = async () => {
    setCleanLoading((prev) => ({ ...prev, processedImages: true }));

    try {
      const resp = await getRequest(
        `EventImages/DeleteAllProcessedImages/${pageId}`,
      );

      if (resp.status === 200) {
        NotificationManager.success("Images cleaned successfully");
        getImageCount();
        getFolderSize();
      }
    } catch (error) {
      console.error("Error deleting images:", error);
    } finally {
      setCleanLoading((prev) => ({ ...prev, processedImages: false }));
    }
  };
  
  const handleCleanIndexedImages = async () => {
    setCleanLoading((prev) => ({ ...prev, indexedImages: true }));

    try {
      const resp = await getRequest(
        `EventImages/DeleteAllProcessedImagesByFace/${pageId}`,
      );

      if (resp.status === 200) {
        NotificationManager.success("Images cleaned successfully");
        getImageCount();
        getFolderSize();
      }
    } catch (error) {
      console.error("Error deleting images:", error);
    } finally {
      setCleanLoading((prev) => ({ ...prev, indexedImages: false }));
    }
  };

  const handleCleanUnprocessedImages = async () => {
    setCleanLoading((prev) => ({ ...prev, unprocessedImages: true }));

    try {
      const resp = await getRequest(
        `S3/DeleteFolder/${pageId}/UnProcessedImages`,
      );

      if (resp.status === 200) {
        NotificationManager.success("Images cleaned successfully");
        getImageCount();
        getFolderSize();
      }
    } catch (error) {
      console.error("Error deleting images:", error);
    } finally {
      setCleanLoading((prev) => ({ ...prev, unprocessedImages: false }));
    }
  };

  const getFolderSize = async () => {
    try {
      const resp = await getRequest(`S3/GetFoldersSize/${pageId}`);
      setFolderSize(resp.data);
    } catch (error) {
      console.error("Error fetching sizes:", error);
    }
  };

  const handleCleanData = () => {
    getFolderSize();
    setIsCleanModalOpen(true);
  };

  const handleDownloadExcel = async () => {
    try {
      if (!participantData || participantData.length === 0) {
        NotificationManager.error("No participant data available");
        return;
      }

      const autoRequestIds = autoReelRequest.map((req) => req.requestId);

      const mailData = participantData
        .filter((participant) => participant.reels.length > 0 && participant.reels.some(reel => autoRequestIds.includes(reel.requestId)))
        .map((participant) => ({
          bibNo: participant.bibNo,
          completionTime: participant.completionTime,
          email: participant.email,
          participantName: participant.participantName,
          ticketName: participant.ticketName,
          reelPath: participant.reels[0]?.reelPath || "",
        }));

      if (mailData.length === 0) {
        NotificationManager.error("No participant data available");
        return;
      }

      const response = await postRequest(`S3/DownloadExcel`,
        mailData,
        {
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `${eventData?.pageTitle || "Participants"}_Reels.xlsx`;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      NotificationManager.success("Excel downloaded successfully");
    } catch (error) {
      console.error(error);
      NotificationManager.error("Failed to download Excel");
    }
  };

  return (
    <MainA className="b-event-clip-list">
      {loading && <Loader loading={loading} />}
      <Modal
        isOpen={isAddImageModalOpen}
        closeModal={() => setIsAddImageModalOpen(false)}
      >
        <div className="gallery-add-image">
          <img src={uploadImage} alt="" />
          <form onSubmit={handleSubmit}>
            <div className="upload-image-form">
              <div className="enter-name">
                <label htmlFor="galleryFileTitle">Clip Name:</label>
                <Input
                  id="galleryFileTitle"
                  type="text"
                  value={galleryFileTitle}
                  onChange={handleGalleryFileTitleChange}
                  required
                />
              </div>
              <div className="adjust-width">
                <label htmlFor="image">Upload Clip:</label>
                <Upload
                  onChange={handleUpload}
                  allowedFiles={["mp4", "mov", "avi", "mkv", "webm"]}
                  resetFile={resetFile}
                />
              </div>

              <Button
                className="gallery-btn"
                type="submit"
                disabled={actionLoading}
                title="Submit"
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </Modal>

      <Modal isOpen={isPlayModalOpen} closeModal={handleClosePlayModal}>
        <div className="play-video-modal">
          <video
            ref={playVideoRef}
            src={playUrl}
            controls
            autoPlay
            style={{ width: "100%", borderRadius: "10px", maxHeight: "400px" }}
          />
        </div>
      </Modal>

      <Modal isOpen={isReelModalOpen} closeModal={handleCloseReelModal}>
        <div className="reel-list-modal">
          <h3>Reels</h3>
          <p className="reel-event">
            <span>
              <strong>Bib No: </strong>
              {selectedParticipant.bibNo}
            </span>
            <span>
              <strong>Name: </strong>
              {selectedParticipant.participantName}
            </span>
            <span>
              <strong>Email: </strong>
              {selectedParticipant.email}
            </span>
            <span>
              <strong>Phone No: </strong>
              {selectedParticipant.phoneNo}
            </span>
            <span>
              <strong>Completion Time: </strong>
              {selectedParticipant.completionTime}
            </span>
            <span>
              <strong>Ticket Name: </strong>
              {selectedParticipant.ticketName}
            </span>
          </p>

          {selectedParticipant.reels?.length > 0 ? (
            <table className="reel-table">
              <thead>
                <tr>
                  {/* <th>Request Type</th> */}
                  <th>Created At</th>
                  <th>Reel</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {selectedParticipant.reels.map((reel, index) => (
                  <React.Fragment key={index}>
                    <tr>
                      {/* <td>{RequestTypeLabel[2]}</td> */}
                      <td>
                        {moment(reel.createdAt).format("YYYY-MM-DD HH:mm")}
                      </td>

                      <td className="reel-path">
                        <Button
                          title="Play"
                          onClick={() => handlePlayClick(reel.reelPath)}
                          disabled={!signedReels[reel.reelPath]}
                        >
                          <FontAwesomeIcon icon={faPlay} />
                        </Button>
                      </td>

                      <td>
                        <span className="reel-actions">
                          <Button
                            title="Download"
                            onClick={() =>
                              window.open(signedReels[reel.reelPath])
                            }
                            disabled={!signedReels[reel.reelPath]}
                          >
                            <FontAwesomeIcon icon={faDownload} />
                          </Button>
                          <Button
                            title="Send Email"
                            onClick={() =>
                              handleParticipantMail(selectedParticipant)
                            }
                          >
                            <FontAwesomeIcon icon={faEnvelope} />
                          </Button>
                        </span>
                      </td>
                    </tr>
                    {expandedReelKey === reel.reelPath && (
                      <tr className="reel-expanded-row">
                        <td colSpan={3}>
                          <video
                            ref={(el) =>
                              (reelVideoRefs.current[reel.reelPath] = el)
                            }
                            src={signedReels[reel.reelPath]}
                            controls
                            autoPlay
                            playsInline
                            style={{
                              width: "100%",
                              maxHeight: "360px",
                              borderRadius: "8px",
                            }}
                          />
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No reels found.</p>
          )}
        </div>
      </Modal>

      <Modal isOpen={isCleanModalOpen} closeModal={handleCloseCleanModal} className="clean-data-modal">
        <div className="clean-modal">
          <h3 className="clean-modal-title">Storage Cleanup</h3>

          <table className="clean-table">
            <thead>
              <tr>
                <th>Type</th>
                <th>Files</th>
                <th>Size</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Processed Reels</td>
                <td>{processedCount}</td>
                <td>{folderSize?.[2]?.sizeHuman || "-"}</td>
                <td>
                  <Button
                    onDoubleClick={handleCleanProcessedReels}
                    disabled={
                      processedCount === 0 || cleanLoading.processedReels
                    }
                  >
                    {cleanLoading.processedReels ? "Cleaning..." : "Clean"}
                  </Button>
                </td>
              </tr>

              <tr>
                <td>Processed Images by Bib</td>
                <td>{imageCount?.processedByBibImagesCount || 0}</td>
                <td>{folderSize?.[1]?.sizeHuman || "-"}</td>
                <td>
                  <Button
                    onDoubleClick={handleCleanProcessedImages}
                    disabled={
                      imageCount?.processedByBibImagesCount === 0 ||
                      cleanLoading.processedImages
                    }
                  >
                    {cleanLoading.processedImages ? "Cleaning..." : "Clean"}
                  </Button>
                </td>
              </tr>

              <tr>
                <td>Processed Images by Face</td>
                <td>{imageCount?.processedByFaceImagesCount || 0}</td>
                <td>{folderSize?.[3]?.sizeHuman || "-"}</td>
                <td>
                  <Button
                    onDoubleClick={handleCleanIndexedImages}
                    disabled={
                      imageCount?.processedByFaceImagesCount === 0 ||
                      cleanLoading.indexedImages
                    }
                  >
                    {cleanLoading.indexedImages ? "Cleaning..." : "Clean"}
                  </Button>
                </td>
              </tr>

              <tr>
                <td>Unprocessed Images</td>
                <td>{imageCount?.unprocessedImagesCount || 0}</td>
                <td>{folderSize?.[0]?.sizeHuman || "-"}</td>
                <td>
                  <Button
                    onDoubleClick={handleCleanUnprocessedImages}
                    disabled={
                      imageCount?.unprocessedImagesCount === 0 ||
                      cleanLoading.unprocessedImages
                    }
                  >
                    {cleanLoading.unprocessedImages ? "Cleaning..." : "Clean"}
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="clean-disclaimer">
            ⚠️ Disclaimer: This action permanently deletes files from storage
            and cannot be undone. If you are sure, double click the "Clean"
            button.
          </div>
        </div>
      </Modal>

      <Modal isOpen={faceSegLoading} closeModal={() => {}} className="face-seg-modal">
        <div className="face-modal-content">
          <h3 className="face-modal-title">Segregating Images by Face</h3>

          <p className="face-modal-count">
            Processed: <strong>{faceSegProcessed}</strong> / {faceSegTotal}
          </p>

          <p className="face-modal-remaining">Remaining: {faceSegTotal - faceSegProcessed}</p>

          <div className="face-progress-bar">
            <div
              className="face-progress-fill"
              style={{
                width: `${faceSegTotal ? (faceSegProcessed / faceSegTotal) * 100 : 0}%`,
              }}
            />
          </div>

          <div className="face-modal-disclaimer">
            ⚠️ Disclaimer: Please do NOT close, refresh, or navigate away from this page while processing is in progress. This may interrupt face indexing and leave some participants unprocessed.
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={faceSegConfirmOpen}
        closeModal={() => setFaceSegConfirmOpen(false)}
      >
        <div style={{ textAlign: "center"}}>

          <h3>Start Face Segregation?</h3>

          <p style={{ marginTop: "15px", color: "#666" }}>
            This will segregate images for {unprocessedFaceParticipants.length} participants.
          </p>

          <div
            style={{
              marginTop: "15px",
              padding: "12px",
              background: "#fff3cd",
              color: "#856404",
              borderRadius: "8px",
              fontSize: "14px",
            }}
          >
            ⚠️ Do NOT close or refresh the page once started.
          </div>

          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <Button
              title="Cancel"
              onClick={() => setFaceSegConfirmOpen(false)}
            >
              Cancel
            </Button>

            <Button
              title="Start"
              onClick={() => {
                setFaceSegConfirmOpen(false);
                handleSegregateImagesByFace();
              }}
            >
              Start
            </Button>

          </div>

        </div>
      </Modal>

      <div className="gallery-wrapper">
        <div className="event-header">
          <div className="event-name">
            <h1>Reel Management</h1>
            <p>{eventData?.pageTitle}</p>
          </div>

          <div className="candidate-buttons">
            {/* <Button
              onClick={(e) => {
                e.preventDefault();
                navigate(-1);
              }}
              title="Send Whatsapp Message"  
            >
              <img src={whatsapp} alt="left arrow" />
              Send Whatsapp Message
            </Button> */}
            <Button onClick={handleCleanData} title={"Clean Data"}>
              Clean Data
            </Button>
            <Button
              onClick={handleMail}
              style={{ cursor: "not-allowed" }}
              title={
                isMailDisabled
                  ? "All participants reel must be processed"
                  : "Send Email"
              }
              disabled
            >
              <FontAwesomeIcon icon={faEnvelope} />
              Send Email
            </Button>
            <Button
              onClick={(e) => {
                e.preventDefault();
                navigate(`/events/reel-request/${categoryIdFromQuery}`);
              }}
              title="Requests"
            >
              Requests
            </Button>
            <Button
              onClick={(e) => {
                e.preventDefault();
                navigate(-1);
              }}
              className="back-btn"
              title="Back"
            >
              Back
            </Button>
          </div>
        </div>
        <div className="lower-section">
          <div className="left-container">
            <div className="left-section">
              <div className="add-data">
                <h2>Reel Clips</h2>
                {/* <Button
                  onClick={() => navigate("/clips")}
                  className="add-image-btn"
                >
                  All Clips
                </Button> */}
              </div>
              <div className="clip-content">
                <form onSubmit={handleDriveUrlSubmit}>
                  <div className="upload-image-form">
                    <div className="enter-name">
                      <Input
                        id="driveUrl"
                        type="text"
                        value={driveUrl}
                        onChange={handleDriveUrlChange}
                        placeholder="Enter Drive Url"
                        required
                      />
                    </div>

                    <Button
                      className="gallery-btn"
                      type="submit"
                      disabled={actionLoading}
                      title={driveUrl ? "Update Url" : "Save Url"}
                    >
                      {driveUrl ? "Update Url" : "Save Url"}
                    </Button>
                  </div>
                </form>
                <div className="upload-image-form">
                  {clipData && (
                    <div className="enter-name">
                      <Input
                        id="driveUrl"
                        type="text"
                        value={`${imageUrl}/${clipData?.eventClipFilePath?.replace(
                          /\\/g,
                          "/",
                        )}${clipData?.eventClipFileName}`}
                        onChange={handleDriveUrlChange}
                        placeholder="Enter Drive Url"
                        required
                        disabled
                      />
                    </div>
                  )}

                  <Button
                    onClick={handleAddImage}
                    className="add-image-btn"
                    title={clipData ? "Update Clip" : "Add Clip"}
                  >
                    {clipData ? (
                      "Update Clip"
                    ) : (
                      <>
                        <img src={plus} alt="add icon" /> Add Clip
                      </>
                    )}
                  </Button>
                </div>
                <div className="upload-image-form">
                  {clipData && (
                    <Button
                      className="gallery-btn"
                      onClick={() => {
                        const url = `${imageUrl}/${clipData?.eventClipFilePath.replace(
                          /\\/g,
                          "/",
                        )}${clipData?.eventClipFileName}`;
                        setPlayUrl(url);
                        setIsPlayModalOpen(true);
                      }}
                      title="Play"
                    >
                      <FontAwesomeIcon icon={faPlay} /> Play
                    </Button>
                  )}
                  {clipData && (
                    <CopyToClipboard
                      className="gallery-btn"
                      text={`${imageUrl}/${(
                        clipData?.eventClipFilePath ?? ""
                      ).replace(/\\/g, "/")}${
                        clipData?.eventClipFileName ?? ""
                      }`}
                      onCopy={() => {
                        NotificationManager.success("Copied to clipboard!");
                      }}
                      title="Copy"
                    >
                      <span>
                        <FontAwesomeIcon icon={faCopy} /> Copy
                      </span>
                    </CopyToClipboard>
                  )}
                </div>
              </div>
            </div>
            <div className="left-section">
              <h2>Process Images</h2>
              <div className="clip-content clip-content-2">
                <div className="request-btn-container">
                  <h4>By Bib</h4>
                  <div className="bib-process-container">
                    <Button
                      className="gallery-btn-2"
                      title="Segregate Images by BIB"
                      onClick={handleSegregateImagesByBib}
                      disabled={
                        segregationStatus === "IN_PROGRESS"
                      }
                    >
                      Process & Segregate
                    </Button>
                    {segregationStatus === "SUCCESS" ? (
                      <span className={`status-pill status-3`}>
                        {RequestStatusLabel[3]}
                      </span>
                    ) : (
                      segregationStatus && (
                        <span className={`status-pill status-2`}>
                          {RequestStatusLabel[2]}
                        </span>
                      )
                    )}
                    {segregationStatus && segregationStatus === "IN_PROGRESS" && (
                      <Button
                        onClick={getSegregationStatus}
                        className="refresh-btn"
                        title="Refresh"
                      >
                        <FontAwesomeIcon icon={faRefresh} />
                      </Button>
                    )}
                  </div>
                </div>
                <div className="request-btn-container">
                  <h4>By Face</h4>
                  <div className="bib-process-container">
                    <Button
                      className="gallery-btn-2"
                      title="Process Face Detection"
                      onClick={handleProcessFace}
                      disabled={
                        processByFaceStatus === "IN_PROGRESS"
                      }
                    >
                      Process
                    </Button>
                    {processByFaceStatus === "SUCCESS" ? (
                      <span className={`status-pill status-3`}>
                        {RequestStatusLabel[3]}
                      </span>
                    ) : (
                      processByFaceStatus && (
                        <span className={`status-pill status-2`}>
                          {RequestStatusLabel[2]}
                        </span>
                      )
                    )}
                    {processByFaceStatus && processByFaceStatus === "IN_PROGRESS" && (
                      <Button
                        onClick={getSegregationStatus}
                        className="refresh-btn"
                        title="Refresh"
                      >
                        <FontAwesomeIcon icon={faRefresh} />
                      </Button>
                    )}
                  </div>
                  <div className="bib-process-container">
                    <Button
                      className="gallery-btn-2"
                      title="Segregate Images by Face"
                      onClick={() => setFaceSegConfirmOpen(true)}
                    >
                      Segregate({unprocessedFaceParticipants.length})
                    </Button>
                    {processedFaces && ( 
                      <p>{processedFaces.length} Faces Processed</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="left-section">
              <h2>Process Reels</h2>
              <div className="clip-content">
                <div className="request-btn-container">
                  <Button
                    className="gallery-btn-2"
                    title="Generate Reel"
                    onClick={handleGenerateReel}
                  >
                    Generate Reel
                  </Button>
                  {generateReelStatus && generateReelStatus === "SUCCESS" ? (
                    <span className={`status-pill status-3`}>
                      {RequestStatusLabel[3]}
                    </span>
                  ) : (
                    generateReelStatus &&
                    generateReelStatus === "IN_PROGRESS" && (
                      <span className={`status-pill status-2`}>
                        {RequestStatusLabel[2]}
                      </span>
                    )
                  )}
                  {generateReelStatus &&
                    generateReelStatus === "IN_PROGRESS" && (
                      <Button
                        onClick={getGenerateReelStatus}
                        className="refresh-btn"
                        title="Refresh"
                      >
                        <FontAwesomeIcon icon={faRefresh} />
                      </Button>
                    )}
                </div>
              </div>
            </div>
            <div className="left-section">
              <div className="add-data">
                <h2>Demo Certificate</h2>
              </div>
              <div className="clip-content-2">
                <Button
                  className="gallery-btn-2"
                  title="Bib Certificate"
                  onClick={() => {
                    setCertificateRunType("bib");
                    setShowCertificateViewer(true);
                  }}
                >
                  Bib Certificate
                </Button>
                <Button
                  className="gallery-btn-2"
                  title="Fun Certificate"
                  onClick={() => {
                    setCertificateRunType("fun");
                    setShowCertificateViewer(true);
                  }}
                >
                  Fun Certificate
                </Button>
              </div>
            </div>
            <div className="left-section">
              <div className="add-data">
                <h2>Demo Reel Images</h2>
              </div>
              <Button
                className="demo-reel-btn"
                onClick={handleGenerateDemoReel}
                title="Generate Demo Reel"
                disabled={selectedDemoImages.length === 0}
              >
                Generate Demo Reel
              </Button>
              {demoReelImages.length > 0 && (
                <div className="image-container">
                  {demoReelImages.map((image, index) => (
                    <div
                      className={`image-item ${
                        selectedDemoImages.includes(image.key) ? "selected" : ""
                      }`}
                      key={index}
                      onClick={() => handleSelectDemoImages(image.key)}
                    >
                      <img src={image.url} alt={`Image ${index}`} />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className="participants-table">
              <div className="pills">
                <div
                  className={`pill ${activePill === "ALL" ? "active" : ""}`}
                  onClick={() => handlePillClick("ALL")}
                >
                  All Participant
                  <span>{participantData.length}</span>
                </div>

                <div
                  className={`pill ${
                    activePill === "PROCESSED" ? "active" : ""
                  }`}
                  onClick={() => handlePillClick("PROCESSED")}
                >
                  Processed Reels
                  <span>{processedCount}</span>
                </div>
                <div className={`pill`}>
                  Processed Images by BIB
                  <span>{imageCount.processedByBibImagesCount}</span>
                </div>
                <div className={`pill`}>
                  Processed Images by Face
                  <span>{imageCount.processedByFaceImagesCount}</span>
                </div>
                <div className={`pill`}>
                  Unprocessed Images
                  <span>{imageCount.unprocessedImagesCount}</span>
                </div>
              </div>
            <div className="participants-header">
              <h2>Participants</h2>
              <div className="participants-filters">
                <FontAwesomeIcon
                  onClick={handleDownloadExcel}
                  icon={faFileExcel}
                  title='Download Participant Reel Excel'
                  style={{ color: '#1d6f42' }}
                  className='excel-btn'
                  disabled={participantData.length === 0}
                />
                <Input
                  className="search-input"
                  type="search"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearch}
                />

                <Button
                  className="add-image-btn"
                  onClick={() =>
                    navigate(
                      `/participants?pageId=${pageId}&clientId=${eventData?.clientId}&pageName=${eventData?.pageName}`,
                    )
                  }
                  title="Add Participant"
                >
                  Add Participants
                </Button>
              </div>
            </div>
            <Table
              pagination={true}
              pageSize={10}
              totalRows={filteredData.length}
              categoryName="participants"
            >
              <thead>
                <tr>
                  <th onClick={() => handleSort("bibNo")}>
                    Bib Number{" "}
                    {sortColumn === "bibNo"
                      ? sortOrder === "asc"
                        ? "↑"
                        : "↓"
                      : ""}
                  </th>
                  {/* <th onClick={() => handleSort("ticketName")}>
                    Ticket Name{" "}
                    {sortColumn === "ticketName"
                      ? sortOrder === "asc"
                        ? "↑"
                        : "↓"
                      : ""}
                  </th> */}
                  <th onClick={() => handleSort("participantName")}>
                    Participant Name{" "}
                    {sortColumn === "participantName"
                      ? sortOrder === "asc"
                        ? "↑"
                        : "↓"
                      : ""}
                  </th>
                  {/* <th onClick={() => handleSort("phoneNo")}>
                    Phone No{" "}
                    {sortColumn === "phoneNo"
                      ? sortOrder === "asc"
                        ? "↑"
                        : "↓"
                      : ""}
                  </th> */}
                  <th onClick={() => handleSort("email")}>
                    Email{" "}
                    {sortColumn === "email"
                      ? sortOrder === "asc"
                        ? "↑"
                        : "↓"
                      : ""}
                  </th>
                  <th onClick={() => handleSort("completionTime")}>
                    Completion Time{" "}
                    {sortColumn === "completionTime"
                      ? sortOrder === "asc"
                        ? "↑"
                        : "↓"
                      : ""}
                  </th>
                  <th>Reel Count</th>
                </tr>
              </thead>

              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.bibNo}</td>
                      {/* <td>{item.ticketName}</td> */}
                      <td>{item.participantName}</td>
                      {/* <td>{item.phoneNo}</td> */}
                      <td>{item.email}</td>
                      <td>{item.completionTime}</td>
                      <td>
                        <span
                          className="reel-count-link"
                          onClick={() => handleOpenReelModal(item)}
                          style={{
                            cursor: "pointer",
                            color: "#1e88e5",
                            fontWeight: 600,
                          }}
                        >
                          {item?.reels?.length}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" style={{ textAlign: "center" }}>
                      No participant(s) found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      {showCertificateViewer && (
        <CertificateViewer
          key={`${pageId}-${certificateRunType}`}
          pageId={pageId}
          runType={certificateRunType}
          onClose={() => setShowCertificateViewer(false)}
        />
      )}

    </MainA>
  );
};

export default EventClip;
